import React, { useEffect, useState } from 'react';
import Button from '../../components/button';
import Checkbox from '../../components/checkbox';
import Input from '../../components/input';
import Error from '../../components/error_message';
import { useAngularService } from 'helpers/get_angular_service';
import notification from 'helpers/notification';
import setValue from 'helpers/set_value';

const GymProfileContactDetails = ({ getProfile }) => {
  const [profile, setProfile] = useState<any>({});
  const [errors, setErrors] = useState<any>({});
  const loadingAnimation = useAngularService('loadingAnimation');
  const $http = useAngularService('$http');
  const $rootScope = useAngularService('$rootScope');
  const GTMService = useAngularService('GTMService');

  useEffect(() => {
    loadingAnimation.show();
    GTMService.trackPage('Account Profile - Contact Details');
    getProfile().then((response) => {
      setProfile(response.data);
      loadingAnimation.hide();
    });
  }, []);

  const onValueChange = (value, path) => {
    const updated = setValue(profile, path, value);
    setProfile(updated);
  };

  const save = () => {
    loadingAnimation.show();
    const params = {
      gym: {
        gym_contact_detail_attributes: profile.gym_contact_detail_attributes,
      },
    };

    const url = `gyms/${$rootScope.gym.id}`;

    GTMService.trackPage('Account Profile - Contact Details', 'attempt');
    $http.put(url, params).then(
      () => {
        GTMService.trackPage('Account Profile - Contact Details', 'success');
        loadingAnimation.hide();
        notification.success('Saved successfully');
        setErrors({});
      },
      (response) => {
        GTMService.trackPage('Account Profile - Contact Details', 'error');
        notification.error('Save failed. Please fix the errors below');
        setErrors(response.data.errors);
        loadingAnimation.hide();
      },
    );
  };

  if (!profile.gym_contact_detail_attributes) return null;
  return (
    <div className="content-box first-one">
      <p>
        These contact details are used in Invoices, POS sale receipts, waivers and on your Clubworx
        website
      </p>
      <div className="row">
        <div className="form-group col-md-6">
          <label className="control-label">Street Address - Line 1</label>
          <Input
            value={profile.gym_contact_detail_attributes.street_address_line_1}
            onChange={(val) =>
              onValueChange(val, 'gym_contact_detail_attributes.street_address_line_1')
            }
          />

          <Error error={errors['gym_contact_detail.street_address_line_1']} />
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">Street Address - Line 2</label>
          <Input
            value={profile.gym_contact_detail_attributes.street_address_line_2}
            onChange={(val) =>
              onValueChange(val, 'gym_contact_detail_attributes.street_address_line_2')
            }
          />

          <Error error={errors['gym_contact_detail.street_address_line_2']} />
        </div>
      </div>
      <div className="row">
        <div className="form-group col-md-6">
          <label className="control-label">City</label>
          <Input
            value={profile.gym_contact_detail_attributes.street_address_city}
            onChange={(val) =>
              onValueChange(val, 'gym_contact_detail_attributes.street_address_city')
            }
          />

          <Error error={errors['gym_contact_detail.street_address_city']} />
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">State / Province</label>
          <Input
            value={profile.gym_contact_detail_attributes.street_address_state}
            onChange={(val) =>
              onValueChange(val, 'gym_contact_detail_attributes.street_address_state')
            }
          />

          <Error error={errors['gym_contact_detail.street_address_state']} />
        </div>
      </div>
      <div className="row">
        <div className="form-group col-md-6">
          <label className="control-label">Zip / Postal Code</label>
          <Input
            value={profile.gym_contact_detail_attributes.street_address_postcode}
            onChange={(val) =>
              onValueChange(val, 'gym_contact_detail_attributes.street_address_postcode')
            }
          />

          <Error error={errors['gym_contact_detail.street_address_postcode']} />
        </div>
        <div className="form-group col-md-6">
          <label className="control-label">Country</label>
          <Input
            value={profile.gym_contact_detail_attributes.street_address_country}
            onChange={(val) =>
              onValueChange(val, 'gym_contact_detail_attributes.street_address_country')
            }
          />

          <Error error={errors['gym_contact_detail.street_address_country']} />
        </div>
      </div>
      <div className="row">
        <div className="form-group col-md-4">
          <label className="control-label">Email address</label>
          <Input
            value={profile.gym_contact_detail_attributes.email}
            type="email"
            onChange={(val) => onValueChange(val, 'gym_contact_detail_attributes.email')}
          />

          <Error error={errors['gym_contact_detail.email']} />
        </div>
        <div className="form-group col-md-4">
          <label className="control-label">Phone number</label>
          <Input
            type="tel"
            value={profile.gym_contact_detail_attributes.phone_number}
            onChange={(val) => onValueChange(val, 'gym_contact_detail_attributes.phone_number')}
          />

          <Error error={errors['gym_contact_detail.phone_number']} />
        </div>
        <div className="form-group col-md-4">
          <label className="control-label">Fax number</label>
          <Input
            value={profile.gym_contact_detail_attributes.fax_number}
            onChange={(val) => onValueChange(val, 'gym_contact_detail_attributes.fax_number')}
          />

          <Error error={errors['gym_contact_detail.fax_number']} />
        </div>
      </div>
      <div className="row">
        <div className="form-group col-md-4">
          <label className="control-label">
            {profile.gym_contact_detail_attributes.localized_company_number_label}
          </label>
          <Input
            value={profile.gym_contact_detail_attributes.company_number}
            onChange={(val) => onValueChange(val, 'gym_contact_detail_attributes.company_number')}
          />

          <Error error={errors['gym_contact_detail.company_number']} />
        </div>
        <div className="form-group col-md-4">
          <label className="control-label">Other Registered Number</label>{' '}
          <span className="helper-text">(label)</span>
          <Input
            value={profile.gym_contact_detail_attributes.registered_number_label}
            onChange={(val) =>
              onValueChange(val, 'gym_contact_detail_attributes.registered_number_label')
            }
          />
          <Error error={errors['gym_contact_detail.registered_number_label']} />
        </div>
        <div className="form-group col-md-4">
          <label className="control-label">Other Registered Number</label>{' '}
          <span className="helper-text">(number)</span>
          <Input
            value={profile.gym_contact_detail_attributes.registered_number}
            onChange={(val) =>
              onValueChange(val, 'gym_contact_detail_attributes.registered_number')
            }
          />
          <Error error={errors['gym_contact_detail.registered_number']} />
        </div>
      </div>
      <div>
        <Checkbox
          onChange={(val) => onValueChange(val, 'gym_contact_detail_attributes.copy_to_website')}
          trueValue={1}
          falseValue={0}
          checked={profile.gym_contact_detail_attributes.copy_to_website}
        >
          Apply contact information changes to website
        </Checkbox>

        <Error error={errors['gym_contact_detail.copy_to_website']} />
      </div>
      <div className="margin-top">
        <Button onClick={save} variant="success">
          Save
        </Button>
      </div>
    </div>
  );
};

angular.module('gym').value('GymProfileContactDetails', GymProfileContactDetails);
